// Small reusable "type a name, submit or cancel" modal — overlay + centered
// card, Enter submits, Escape closes. Shared by KuntoarvioWorkspaceV2 (add
// tarkastuskohde, add näyte) and KuntotutkimuksetTab (add PTS project).
export default function AddNameModal({ title, placeholder, value, onChange, onSubmit, onClose }) {
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 1060, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      onClick={onClose}>
      <div style={{ background: '#fff', borderRadius: 10, boxShadow: '0 8px 32px rgba(0,0,0,0.22)', width: 'min(380px, 95vw)', padding: '22px 24px', display: 'flex', flexDirection: 'column', gap: 16 }}
        onClick={e => e.stopPropagation()}>
        <div style={{ fontWeight: 700, fontSize: '0.95rem' }}>{title}</div>
        <input autoFocus type="text" placeholder={placeholder} value={value} onChange={e => onChange(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter' && value.trim()) onSubmit(); if (e.key === 'Escape') onClose(); }}
          style={{ width: '100%', border: '1.5px solid #ced4da', borderRadius: 6, padding: '10px 14px', fontSize: '1rem', outline: 'none', boxSizing: 'border-box' }} />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button type="button" onClick={onClose} className="btn btn-sm btn-outline-secondary">Peruuta</button>
          <button type="button" onClick={onSubmit} disabled={!value.trim()}
            style={{ border: 'none', background: '#198754', color: '#fff', borderRadius: 4, padding: '7px 14px', fontSize: '0.8rem', fontWeight: 600, cursor: value.trim() ? 'pointer' : 'not-allowed', opacity: value.trim() ? 1 : 0.6 }}>
            Lisää
          </button>
        </div>
      </div>
    </div>
  );
}
